import { compsAffectedTooltip } from '../utils/compsAffectedTooltip.js';
import { dateOfSaleAdjTooltip } from '../utils/dateOfSaleAdjTooltip.js';
import { MarketTrendsHelperColumn, MarketTrendsHelpers, MarketTrendsTableRowDef } from './types.js';

const valueShadowedTooltip =
  'Due to insufficient data, the values from the previous month will be used for this period when performing adjustments.';

function makeRow<T>(props: {
  isHeader?: boolean;
  label: string;
  tooltipLabel?: (x: MarketTrendsHelpers) => string;
  tooltipCell?: (x: MarketTrendsHelperColumn) => string | undefined;
  selector: (x: MarketTrendsHelperColumn) => T | undefined;
  formatter: (x: T) => string;
  dfl?: string;
}): MarketTrendsTableRowDef {
  const { isHeader, label, tooltipLabel, tooltipCell, selector, formatter, dfl } = props;
  return {
    isHeader,
    label,
    tooltipLabel,
    tooltipCell,
    isVisible(cols: MarketTrendsHelperColumn[]): boolean {
      return cols.some((x) => selector(x) !== undefined);
    },
    cellContent(col: MarketTrendsHelperColumn): string {
      const value = selector(col);
      return (value === undefined ? dfl : formatter(value)) ?? '';
    },
  };
}

export const marketTrendsTableRows: MarketTrendsTableRowDef[] = [
  makeRow({
    isHeader: true,
    label: '',
    tooltipCell: (x) => (x.shadowed ? valueShadowedTooltip : undefined),
    selector: (x) => x.period,
    formatter: (x) => x,
  }),
  makeRow({
    label: 'Median Close Price',
    selector: (x) => x.p50closeprice,
    formatter: (x) => x.toString(true),
    dfl: '-',
  }),
  makeRow({
    label: 'Median List Price',
    selector: (x) => x.p50listprice,
    formatter: (x) => x.toString(true),
    dfl: '-',
  }),
  makeRow({
    label: 'Median SP as % LP',
    selector: (x) => x.p50closepriceoverlistprice,
    formatter: (x) => (x * 100).toFixed(1) + '%',
    dfl: '-',
  }),
  makeRow({
    label: 'Median DOM',
    selector: (x) => x.p50daysonmarketclosed,
    formatter: (x) => x.toFixed(0),
    dfl: '-',
  }),
  makeRow({
    label: 'Num. Closed Sales',
    selector: (x) => x.numcloses,
    formatter: (x) => x.toFixed(0),
    dfl: '-',
  }),
  makeRow({
    label: 'Date of Sale Adj.',
    tooltipLabel: () => dateOfSaleAdjTooltip('Median Close Price'),
    selector: (x) => x.adjpercent,
    formatter: (x) => (x * 100).toFixed(2) + '%',
    dfl: '-',
  }),
  makeRow({
    label: 'Comps Affected',
    tooltipLabel: () => compsAffectedTooltip('MLS data'),
    selector: (x) => x.comps,
    formatter: (x) => x.join(', '),
  }),
];
